import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';
import LoginPage from './pages/LoginPage';
import DashboardLayout from './pages/DashboardLayout';
import DashboardHome from './pages/DashboardHome';
import MembersPage from './pages/MembersPage';
import DocumentsPage from './pages/DocumentsPage';
import AlertsPage from './pages/AlertsPage';
import EventsPage from './pages/EventsPage';
import SupersetPage from './pages/SupersetPage';
import DevicesPage from './pages/DevicesPage';
import SettingsPage from './pages/SettingsPage';
import NotifyPage from './pages/NotifyPage';
import RiskPage from './pages/RiskPage';
import MapPage from './pages/MapPage';
import LivePage from './pages/LivePage';
import HeatmapPage from './pages/HeatmapPage';
import AICenterPage from './pages/AICenterPage';
import NotificationsPage from './pages/NotificationsPage';
import ImportPage from './pages/ImportPage';
import SessionsPage from './pages/SessionsPage';
import BehaviorPage from './pages/BehaviorPage';

function PrivateRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: 'var(--bg-void)' }}>
      <div style={{ color: 'var(--accent)', fontFamily: 'var(--font-mono)', fontSize: 14 }}>Chargement...</div>
    </div>
  );
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

function SocketProviderWrapper({ children }) {
  const { token } = useAuth();
  return <SocketProvider token={token}>{children}</SocketProvider>;
}

export default function App() {
  return (
    <AuthProvider>
      <SocketProviderWrapper>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: 'var(--bg-elevated)',
            color: 'var(--text-primary)',
            border: '1px solid var(--border)',
            fontFamily: 'var(--font-display)',
            fontSize: 13,
          },
          duration: 4000,
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<PrivateRoute><DashboardLayout /></PrivateRoute>}>
            <Route index element={<DashboardHome />} />
            <Route path="members" element={<MembersPage />} />
            <Route path="documents" element={<DocumentsPage />} />
            <Route path="alerts" element={<AlertsPage />} />
            <Route path="events" element={<EventsPage />} />
            <Route path="superset" element={<SupersetPage />} />
            <Route path="devices" element={<DevicesPage />} />
                        <Route path="risk" element={<RiskPage />} />
            <Route path="map" element={<MapPage />} />
            <Route path="live" element={<LivePage />} />
              <Route path="heatmap" element={<HeatmapPage />} />
              <Route path="ai-center" element={<AICenterPage />} />
              <Route path="notifications" element={<NotificationsPage />} />
              <Route path="import" element={<ImportPage />} />
              <Route path="sessions" element={<SessionsPage />} />
            <Route path="behavior" element={<BehaviorPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="notify" element={<NotifyPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </SocketProviderWrapper>
    </AuthProvider>
  );
}
// 1780226174
